import { useEffect } from 'react';
import { useAppStore } from './store';

/** Applies Settings.theme to <html data-theme> and keeps the browser bar colour in step. */
export function useTheme() {
  const theme = useAppStore((s) => s.settings.theme);
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'system') root.removeAttribute('data-theme');
    else root.setAttribute('data-theme', theme);

    const metas = document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]');
    if (theme === 'system') {
      // index.html ships one tag per scheme; restore their own values.
      metas.forEach((m) => m.dataset.system && (m.content = m.dataset.system));
      return;
    }
    const chassis = getComputedStyle(root).getPropertyValue('--chassis').trim();
    metas.forEach((m) => {
      m.dataset.system ??= m.content;
      m.content = chassis;
    });
  }, [theme]);
}
